import { render } from "./supplier-password.vue?vue&type=template&id=dad0ed62"
import script from "./supplier-password.vue?vue&type=script&lang=js"
export * from "./supplier-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__